

export class ChunksManager {
  constructor(storage, pipeService, req, util) {
    this.storage = storage;
    this.pipeService = pipeService;
    this.req = req;
    this.util = util;
    this.itemListeners();
  }

  async getChunkApi(app_id, chunk_id) {
    try {
      const response = await this.req.axiosRequest({
        url: `${this.req.root}/api/get-items-chunk/${app_id}/${chunk_id}`,
        method: 'GET'
      });
      return response;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async getLastChunkApi(app_id) {
    try {
      const response = await this.req.axiosRequest({
        url: `${this.req.root}/api/get-last-items-chunk/${app_id}`,
        method: 'GET'
      });
      return response;
    } catch (err) {
      console.log(err);
      return null;
    }
  }


  getChunk(app_id, chunk_id) {
   return this.getChunkApi(app_id, chunk_id);
  }


  async getChunks(app_id, chunk_ids) {
    let chunks = [];
    if(chunk_ids){
      chunks = await Promise.all(chunk_ids.map((chunk_id) => this.getChunkApi(app_id, chunk_id)));
    }
    return chunks;
  }


  async getLastChunk(app_id) {
    let chunk = await this.getLastChunkApi(app_id);
    return chunk;
  }

 
  itemListeners() {
  }

  async getApp(app_id) {
    if (!app_id) return null;
    let app = this.getAppFromStorage(app_id);
    if (!app) {
      if (this.getAppPromises[app_id]) {
        return this.getAppPromises[app_id];
      }
      this.getAppPromises[app_id] = this.getAppApi(app_id);
      app = await this.getAppPromises[app_id];
      if (app) {
        this.saveAppInStorage(app);
        this.ws.addSubscription(app_id);
      } else {
        return null;
      }
    }
    return app;
  }
  
  
}
